import React from 'react';
import {
  FlexColumn,
  FormField,
  PasswordField,
  TextField,
  formFieldRequiredLabel as requiredLabel,
} from '@elementary/common-ui/components';
import { useFormContext } from 'react-hook-form';
import { SplunkActivityLogsIntegrationFormValues } from './activityLogsIntegrationUtils';
const SplunkActivityLogsForm = () => {
  const methods = useFormContext<SplunkActivityLogsIntegrationFormValues>();
  const {
    register,
    setValue,
    formState: { dirtyFields, errors },
  } = methods;

  return (
    <FlexColumn sx={{ gap: 3 }}>
      <FormField title="Connection name" errorMessage={errors.name?.message}>
        <TextField
          {...register('name', { required: requiredLabel })}
          variant="outlined"
          size="large"
          placeholder="Connection name"
        />
      </FormField>

      <FormField
        title="HEC URL"
        errorMessage={errors.properties?.hec_url?.message as string}
      >
        <TextField
          {...register('properties.hec_url', { required: requiredLabel })}
          variant="outlined"
          size="large"
          placeholder="e.g. https://example.splunkcloud.com:8088"
        />
      </FormField>

      <FormField
        title="HEC token"
        errorMessage={errors.properties?.token?.message as string}
      >
        <PasswordField
          {...register('properties.token', { required: requiredLabel })}
          size="large"
          isFormValueDirty={dirtyFields.properties?.token}
          clearFormValue={() => setValue('properties.token', '')}
          placeholder="Paste your Splunk HEC token"
        />
      </FormField>

      <FormField title="Index" optional>
        <TextField
          {...register('properties.index')}
          variant="outlined"
          size="large"
          placeholder="Optional"
        />
      </FormField>
    </FlexColumn>
  );
};

export default SplunkActivityLogsForm;
